export default __webpack_public_path__ + "static/media/Animals-15.6a7926de.png";